import { render, staticRenderFns } from "./ProductsToUpload.vue?vue&type=template&id=c71b5996&"
import script from "./ProductsToUpload.vue?vue&type=script&lang=js&"
export * from "./ProductsToUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports